import { useIntl } from 'react-intl';

import { AnalyticalVariable } from '@verantos-dev/types-cohorts';

import {
  deriveCategoryFromAnalyticalVariable,
  type AnalyticalVariableCategory,
} from '../utils/analyticalVariable.utils';

/**
 * Derives the category and its i18n label from an analytical variable's logic.
 * Reusable by any component that needs the category (detail modal header, criteria card, etc.).
 *
 * Returns `category: null` and `categoryLabel: null` for AVs with no structured
 * logic tree (SQL-only AVs). Callers should skip rendering the category row in
 * that case rather than substituting a default label.
 */
export const useAnalyticalVariableCategory = (analyticalVariable: AnalyticalVariable) => {
  const intl = useIntl();
  const category: AnalyticalVariableCategory | null =
    deriveCategoryFromAnalyticalVariable(analyticalVariable);
  const categoryLabel = category
    ? intl.formatMessage({
        id: `projects.analyticalVariables.detailModal.category.${category}`,
      })
    : null;

  return { category, categoryLabel };
};
